<template>
  <div class="news-list">
    <!-- 第一条：推荐阅读（只显示标题） -->
    <div v-if="featuredItem" class="news-list__featured" @click="goDetail(featuredItem)">
      <div class="news-list__badge">
        <span class="news-list__badge-top">推荐</span>
        <div class="news-list__badge-bottom">
          <span class="news-list__badge-text">阅读</span>
        </div>
      </div>
      <span class="news-list__featured-title">{{ featuredItem.title }}</span>
    </div>

    <!-- 第2~4条 -->
    <template v-for="(item, idx) in restItems">
      <!-- 分割线（第2条和第3条之间、第3条和第4条之间） -->
      <div v-if="idx > 0" :key="'line-' + idx" class="news-list__divider"></div>

      <!-- 有图片：图文样式 -->
      <div v-if="item.coverImage" :key="'thumb-' + idx" class="news-list__thumb-item" @click="goDetail(item)">
        <div class="news-list__thumb-text">
          <span class="news-list__thumb-title">{{ item.title }}</span>
          <span class="news-list__thumb-meta">{{ item.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.publishTime }}</span>
        </div>
        <img
          class="news-list__thumb-image"
          referrerpolicy="no-referrer"
          :src="item.coverImage"
          alt="新闻配图"
        />
      </div>
      
      <!-- 无图片：纯标题样式 -->
      <div v-else :key="'text-' + idx" class="news-list__text-item" @click="goDetail(item)">
        <span class="news-list__text-title">{{ item.title }}</span>
        <span class="news-list__text-meta">{{ item.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.publishTime }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    featuredItem() {
      return this.items.length > 0 ? this.items[0] : null;
    },
    restItems() {
      return this.items.slice(1, 4); // 取第2~4条
    }
  },
  methods: {
    goDetail(item) {
      if (!item || !item.newsCode) return;
      this.$router.push(`/detail?newsCode=${item.newsCode}`);
    }
  }
};
</script>

<style scoped>
.news-list {
  width: var(--content-width);
}

/* ══════ 推荐阅读（第一条） ══════ */
.news-list__featured {
  display: flex;
  align-items: center;
  background-color: var(--color-bg-card);
  border-radius: var(--radius-lg);
  width: var(--content-width);
  height: 120px;
  margin-bottom: 28px;
  cursor: pointer;
}

.news-list__badge {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 62px;
  height: 72px;
  background-color: var(--color-white);
  border: 1px solid var(--color-accent-red);
  border-radius: var(--radius-md);
  margin-left: 27px;
  flex-shrink: 0;
}

.news-list__badge-top {
  display: block;
  width: 57px;
  height: 32px;
  color: var(--color-black);
  font-size: var(--font-lg);
  font-family: var(--font-primary);
  text-align: center;
  white-space: nowrap;
  line-height: 32px;
  margin: 3px auto 0;
}

.news-list__badge-bottom {
  background-color: var(--color-accent-red);
  border-radius: var(--radius-md);
  height: 34px;
  width: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
}

.news-list__badge-text {
  color: var(--color-white);
  font-size: var(--font-lg);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 32px;
}

.news-list__featured-title {
  display: block;
  flex: 1;
  color: var(--color-text-gray);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
  margin-left: 36px;
}

/* ══════ 分割线 ══════ */
.news-list__divider {
  width: var(--content-width);
  height: 1px;
  background-color: #EBEBEB;
  margin: 20px 0;
}

/* ══════ 有图片的条目（图文样式） ══════ */
.news-list__thumb-item {
  display: flex;
  justify-content: space-between;
  width: var(--content-width);
  height: 160px;
  cursor: pointer;
}

.news-list__thumb-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 475px;
  height: 160px;
}

.news-list__thumb-title {
  display: block;
  color: var(--color-text-dark);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  line-height: 50px;
}

.news-list__thumb-meta {
  display: block;
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 18px;
  margin-bottom: 10px;
}

.news-list__thumb-image {
  width: 272px;
  height: 153px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}

/* ══════ 无图片的条目（纯标题样式） ══════ */
.news-list__text-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: var(--content-width);
  height: 77px;
  cursor: pointer;
}

.news-list__text-title {
  display: block;
  width: var(--content-width);
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
}

.news-list__text-meta {
  display: block;
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 18px;
  margin-top: 9px;
}
</style>
